import { tokenomicsMobileSVGs } from "../svgs/tokenomics/mobileLines";

export const mobilePieLabels = [
  {
    id: 1,
    title: "Partnership",
    percentage: "5%",
    description: "",
    isGreen: true,
    Bg: tokenomicsMobileSVGs.G1,
    level: '-14', //if slanted down
  },
  {
    id: 2,
    title: "Marketing",
    percentage: "3%",
    description: "locked 6 months, release 1% yearly",
    isGreen: true,
    Bg: tokenomicsMobileSVGs.G2,
    level: 2, //if straight
  },
  {
    id: 2,
    title: "Development",
    percentage: "4%",
    description: "locked 1 year, release 1% yearly",
    isGreen: true,
    Bg: tokenomicsMobileSVGs.G3,
    level: 16, //if slanted up
  },
  {
    id: 4,
    title: "Exchange and MM",
    percentage: "12.8%",
    description: "",
    isGreen: true,
    Bg: tokenomicsMobileSVGs.G4,
    level: 2,
  },
  {
    id: 5,
    title: "Game Ecosystem",
    percentage: "14%",
    description: "",
    isGreen: true,
    Bg: tokenomicsMobileSVGs.G5,
    level: -12,
  },
  {
    id: 6,
    title: "Staking",
    percentage: "28%",
    description: "",
    isGreen: false,
    Bg: tokenomicsMobileSVGs.W1,
    level: 16,
  },
  {
    id: 7,
    title: "LP",
    percentage: "10.2%",
    description: "",
    isGreen: false,
    Bg: tokenomicsMobileSVGs.W2,
    level: 2,
  },
  {
    id: 8,
    title: "Presale",
    percentage: "20%",
    description: "",
    isGreen: false,
    Bg: tokenomicsMobileSVGs.W3,
    level: 2,
  },
  {
    id: 9,
    title: "Team",
    percentage: "3%",
    description: "locked 6 months, release 1% yearly",
    isGreen: false,
    Bg: tokenomicsMobileSVGs.W4,
    level: -10,
  },
];
